//@flow
import * as React from 'react';
import Icon from './CustomIcon';

const iconFactory = ({ Component, applyTheme = true }) => {
    class ComponentWithIcon extends React.PureComponent<$FlowFixMeProps> {
        render() {
            const { icon, theme, ...others } = this.props;
            const customIcon = (
                <Icon theme={applyTheme ? theme : {}} icon={icon} />
            );
            return <Component icon={customIcon} theme={theme} {...others} />;
        }
    }
    ComponentWithIcon.displayName = Component.displayName
        ? Component.displayName
        : '';
    return ComponentWithIcon;
};

export { iconFactory };
export default iconFactory;
